import React from 'react'
import SuperUserPageSF from '../../../templates/SuperUserPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import LoanSanctionSF from '../../../components/superUser/loan/LoanSanctionSF'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import Currency from "../../../components/common/Currency"

const LoanSanctionPageUI = ({context, errorList, loan, cibilRankList}) =>
  <SuperUserPageSF context={context} className='pg_su_loan_a'
    headerText={`Sanction loan: ${loan ? loan.account.accountName : ''}`}
     centered={!loan || !errorList || !cibilRankList}
     backLink={`/su/loans/${loan ? loan.loanId : ''}`}
    >
    {
      (!loan || !errorList || !cibilRankList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && cibilRankList &&
      <div>
        <PageTitleUI context={context} goBack={true}
          backLink={`/su/loans/${loan ? loan.loanId : ''}`}
          titleText={`Sanction loan: ${loan ? loan.account.accountName : ''}`} />
        <LoanSanctionSF context={context} loan={loan} cibilRankList={cibilRankList} />
      </div>
    }

  </SuperUserPageSF>

export default LoanSanctionPageUI
